import React, { createContext, useContext } from "react";
var DeviceContext = /*#__PURE__*/createContext(undefined);
DeviceContext.displayName = "DeviceContext";
export var useDevice = function useDevice() {
  return useContext(DeviceContext);
};
export var DeviceProvider = function DeviceProvider(_ref) {
  var children = _ref.children,
      device = _ref.device;
  return /*#__PURE__*/React.createElement(DeviceContext.Provider, {
    value: device
  }, children);
};
//# sourceMappingURL=useDevice.js.map